export function PMSLocation({
    uid,
    id,
    name,
    timezone,
    customization,
    protect,
    protectStatus,
    reservations,
    hasActiveReservation,
    hasWifiDevices,
    hasDisconnectedDevices,
    hasLockDevices,
    deviceBattery,
    tags,
    vacationRentalPlan,
    urlRecommendations,
    travelerDiscount,
    externalVideoUrl,
    hasIntegration,
    hasIntegrationError,
    pendingEarlyCheckinCount,
    organizationName,
    organizationUid,
    permissionType,
} = {}) {
    return {
        uid,
        id,
        name,
        timezone,
        customization,
        protect,
        protectStatus,
        reservations,
        hasActiveReservation,
        hasWifiDevices,
        hasDisconnectedDevices,
        hasLockDevices,
        deviceBattery,
        tags,
        vacationRentalPlan,
        urlRecommendations,
        travelerDiscount,
        externalVideoUrl,
        hasIntegration,
        hasIntegrationError,
        pendingEarlyCheckinCount,
        organizationName,
        organizationUid,
        permissionType,
    };
}